module.exports = __webpack_public_path__ + "media/purple-circle.7db4043b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/en/images/simple/purple-circle.svg
// module id = 892
// module chunks = 0